import { render, staticRenderFns } from "./updateCarryOverAffiliate.vue?vue&type=template&id=67cbec9c&lang=pug"
import script from "./updateCarryOverAffiliate.vue?vue&type=script&lang=js"
export * from "./updateCarryOverAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports